import { render, staticRenderFns } from "./ExchangeManagements.vue?vue&type=template&id=b5f1865a"
import script from "./ExchangeManagements.vue?vue&type=script&lang=js"
export * from "./ExchangeManagements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports